import { ToastContainer } from "react-toastify";
import { HashRouter } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import Main from "./Components/Routes/Main";
import { useGetRoleInfo } from "./utils/commonComponent/common";
// import "./Components/dashboard/style.css";

function App() {
  const rolesInfo = useGetRoleInfo();  
  return (
    <HashRouter>
      <Main rolesInfo={rolesInfo} />
       <ToastContainer />
        <footer id="footerScroll">
          <a href="tel:+919769847865" className="name">
            <CallIcon style={{ fontSize: "11px" }} /> Pravin Kashid
          </a>
          <span>•</span>
          <span className="copyright full">
            Copyright © 2022 - 2026 <b>All Right Reserved By BFI</b>
          </span>
          <span className="copyright short">
            © 2022-26 <b>All Right Reserved By BFI</b>
          </span>
          <span>•</span>
          <a href="mailto:Info@bfiinfotech.co.in" className="email">
            info@bfiinfotech.co.in
          </a>
        </footer>
    </HashRouter>
  );
}

export default App;